import { render, staticRenderFns } from "./time_span.vue?vue&type=template&id=1ec48942"
import script from "./time_span.vue?vue&type=script&lang=js"
export * from "./time_span.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports